/**
 * 火山 APM 不上报的 JS 错误列表（三项目保持一致，新增请同步改）
 * - message: 匹配 error_message / message
 * - name: 可选，匹配 error_name / name（如 NotAllowedError）
 */
export const APM_IGNORE_JS_ERRORS = [
  // 跨域脚本脱敏，无栈无定位价值
  { message: /^Script error\.?$/i },
  // 非用户手势触发的 media.play()，浏览器策略限制
  {
    name: 'NotAllowedError',
    message: /play\(\) can only be initiated by a user gesture/i
  },
  // 请求/操作被主动取消
  { name: 'AbortError', message: /The operation was aborted/i },
  // play 被 pause 打断（媒体快速切换/重播）
  {
    name: 'AbortError',
    message: /The play\(\) request was interrupted by a call to pause/i
  },
  // 业务未登录提示，非真实异常
  { name: 'Error', message: /请登录后重试/ },
  // 这是 Safari/WebKit 的典型报错，含义是「函数参数列表里少了逗号或运算符」（例如 fn(a s)），多为第三方注入或动态脚本，业务包本身可解析
  {
    name: 'SyntaxError',
    message: /Unexpected identifier ['"]s['"]\. Expected '\)' to end an argument list/i
  },
  // Android 原生分享成功回调 window.share.success，业务未挂时的兼容噪音
  {
    name: 'TypeError',
    message: /share\.success is not a function/i
  },
  // 不是业务代码逻辑错误。堆栈落在 encryptApi → nativeGetApiEncryption，是 Android WebView 在桥接已失效时（快速退出、预加载壳回收等）由 Chromium 抛出的系统错误。
  { message: /Java bridge method invocation error/i }
];

function getApmErrorMessage(event) {
  return String(
    event?.payload?.error_message ||
      event?.payload?.message ||
      event?.payload?.error?.message ||
      ''
  );
}

function getApmErrorName(event) {
  return String(
    event?.payload?.error_name ||
      event?.payload?.name ||
      event?.payload?.error?.name ||
      event?.payload?.type ||
      ''
  );
}

export function shouldIgnoreApmJsError(event) {
  const msg = getApmErrorMessage(event);
  const name = getApmErrorName(event);
  return APM_IGNORE_JS_ERRORS.some(rule => {
    // 以 message 为主（类型字段常为空/--）；同时配了 name 时做辅助校验
    if (rule.message) {
      if (!rule.message.test(msg)) return false;
      if (rule.name && name && name !== '--' && name !== rule.name) return false;
      return true;
    }
    return !!(rule.name && rule.name === name);
  });
}

/** @param {string} preloadPid 预加载壳页 pid，如 /h5_fe_article/html/ */
export function createApmBeforeSend(preloadPid) {
  return event => {
    if (preloadPid && event?.common?.pid === preloadPid) return false;
    if (shouldIgnoreApmJsError(event)) return false;
    return event;
  };
}
